export const HIDDEN_AXIS_LINE_COLOR = 'rgba(0, 0, 0, 0)';
export const HIDDEN_AXIS_LINE_WIDTH = 0;

// 2 - 9
export const COLOR_STEPS_OPTIONS_OFFSET = 2;
export const COLOR_STEPS_OPTIONS = Array(8)
  .fill(0)
  .map((_, i) => {
    return {
      label: (i + COLOR_STEPS_OPTIONS_OFFSET).toString(),
      value: i,
    };
  });

export const BORDER_WIDTH_RANGE_MIN = 0;
export const BORDER_WIDTH_RANGE_MAX = 10;

export const FONT_SIZE_MULTIPLIER = 1.5;
export const ITEM_MARGIN_BOTTOM_MULTIPLIER = 0.75;
export const Y_LEGEND_OFFSET = 1;

export const DATA_TABLE_MODAL_ID = 'modal-preview-container';

export const WIDGET_RENDER_DELAY = 500;
